// AUTO-GENERATED. Do not edit. Run scripts/generate-version.mjs.
export const APP_VERSION = {
  version: '0.5.1',
  gitSha: 'c54ebe1',
  buildDate: '2026-06-29T20:37:59.990Z',
} as const;
